import { h, Fragment } from "preact";
import styles from './style.css';

const StopInfo = props => {
    let { nearbyStops, stopsLoaded, formData } = props;
    if (!stopsLoaded) {
        return '';
    }
    let stopText;
    if ( nearbyStops === 1) {
        stopText = (<Fragment>There is <strong>1 bus stop</strong></Fragment>);
    }  else if (nearbyStops > 1) {
        stopText = (<Fragment>There are <strong>{nearbyStops.toString()} bus stops</strong></Fragment>)
    } else {
        stopText = 'No bus stops found';
    }
    return '';
}

export default StopInfo;